import React from 'react';
import BrandLogo from './BrandLogo';

function Footer() {
  return (
    <footer className="clean-footer crev">
      <div className="container pb-40 pt-40 ontop">
        <div className="row justify-content-between">
          <div className="col-lg-2">
            <div className="md-mb80">
              <a href="/" style={{ textDecoration: 'none' }}>
                <BrandLogo variant="footer" />
              </a>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="column md-mb50">
              <h6 className="sub-title mb-30">İletişim</h6>
              <h6 className="p-color fw-400">
                Hafta içi / Hafta sonu 09:00 – 21:00
              </h6>
              <h6 className="mt-30 mb-15">
                <a href="mailto:kanusdigital@gmail.com">kanusdigital@gmail.com</a>
              </h6>
              <a href="tel:+905393183852" className="underline">
                <span className="fz-22 main-color">+90 539 318 38 52</span>
              </a>
            </div>
          </div>
          <div className="col-lg-2">
            <div className="column md-mb50">
              <h6 className="sub-title mb-30">Hızlı Linkler</h6>
              <ul className="rest fz-14 opacity-7">
                <li className="mb-15">
                  <a href="/page-about">Hakkımızda</a>
                </li>
                <li className="mb-15">
                  <a href="/page-services">Hizmetler</a>
                </li>
                <li className="mb-15">
                  <a href="/portfolio">Portfolio</a>
                </li>
                <li className="mb-15">
                  <a href="/blog-classic">Blog</a>
                </li>
                <li className="mb-15">
                  <a href="/sablonlar">Şablonlar</a>
                </li>
                <li>
                  <a href="/page-contact">İletişim</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="column subscribe-minimal">
              <h6 className="sub-title mb-30">Bülten</h6>
              <div className="form-group mb-40">
                <input type="text" name="subscrib" placeholder="E-posta Adresiniz" />
                <button>
                  <span className="ti-location-arrow"></span>
                </button>
              </div>
              <ul className="rest social-icon d-flex align-items-center">
                <li className="hover-this cursor-pointer">
                  <a
                    href="https://www.instagram.com/kanusdigital/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover-anim"
                  >
                    <i className="fab fa-instagram"></i>
                  </a>
                </li>
                <li className="hover-this cursor-pointer ml-10">
                  <a
                    href="https://www.tiktok.com/@kanusdigital"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover-anim"
                  >
                    <i className="fab fa-tiktok"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="pt-30 pb-30 mt-80 bord-thin-top">
          <div className="text-center">
            <p className="fz-14">
              © {new Date().getFullYear()} Kanus Digital — Tüm hakları saklıdır.
            </p>
          </div>
        </div>
      </div>
      <div className="circle-blur">
        <img src="/assets/imgs/patterns/blur1.png" alt="" />
      </div>
    </footer>
  );
}

export default Footer;
